<template>
  <v-container fluid class="px-0">

    <v-tabs
      class="account-info-tabs"
      style=""
      :show-arrows="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
      :right="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
      :value="infoTab"
      @change="$store.commit('account/setInfoTab', $event)"
    >
      <v-tab :key="`dashboard`" :href="`#dashboard`">Dashboard</v-tab>
      <v-tab :key="`finance`" :href="`#finance`">Finance</v-tab>
      <v-tab :key="`statistic`" :href="`#statistic`">Statistic</v-tab>
      <v-tab :key="`bonuses`" :href="`#bonuses`">Bonuses</v-tab>
      <v-tab :key="`game-history`" :href="`#game-history`">Game History</v-tab>
      <v-tab :key="`sport-history`" :href="`#sport-history`">Sport History</v-tab>
      <v-tab v-if="$store.state.auth.checkAccess({key: 'duplicates', value: true})" :key="`duplicates`" :href="`#duplicates`">Duplicates</v-tab>
      <v-tab v-if="$store.state.auth.checkAccess({key: 'limits', value: true})" :key="`limits`" :href="`#limits`">Limits</v-tab>
    </v-tabs>

    <div class="v-card--material__header d-flex align-center v-card v-sheet elevation-10 green mr-7 ml-7 mt-3 mb-5" style="min-height: 55px;">
      <v-simple-table
        v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
        class="pa-0 col-12"
      >
        <template v-slot:default>
          <tbody>
            <tr>
              <th class="text-left">ID</th>
              <td>{{ activeAccount.account.account_id }}</td>
            </tr>

            <tr>
              <th class="text-left">Login (Project: {{ activeAccount.account.project }})</th>
              <td>{{ activeAccount.account.login }}
                <v-icon small :title="activeAccount.account.platform">{{ platform }}</v-icon>
                <v-icon color="yellow darken-3" v-if="activeAccount.account.vip">mdi-chess-king</v-icon>
              </td>
            </tr>

            <tr>
              <th class="text-left">Status</th>
              <td>{{ accountStatus() }}</td>
            </tr>

            <tr>
              <th class="text-left">Type</th>
              <td>{{ activeAccount.account.type }}</td>
            </tr>

            <tr>
              <th class="text-left">Online</th>
              <td>{{ activeAccount.account.online ? 'On' : 'Off' }}</td>
            </tr>

            <tr>
              <th class="text-left">VIP</th>
              <td align="right">
                <v-checkbox
                  v-model="activeAccount.account.vip"
                  hide-details
                  class="ma-0"
                  :readonly="!$store.state.auth.checkAccess({key: 'vip_update', value: true})"
                  v-on:change="!$store.state.auth.checkAccess({key: 'vip_update', value: true}) || toUpdate($event, 'vip', 'Confirm VIP changes?')"
                ></v-checkbox>
              </td>
            </tr>

            <tr>
              <th class="text-left">Duplicates</th>
              <td v-html="duplicates"></td>
            </tr>

            <tr>
              <th class="text-left">Balance</th>
              <td>{{ activeAccount.account.balance || 0 }} {{ activeAccount.account.currency }}</td>
            </tr>
            <tr>
              <th class="text-left">Withdraw Allowed</th>
              <td>
                {{ activeAccount.account.withdraw_allowed || 0 }} {{ activeAccount.account.currency }}
              </td>
            </tr>
            <tr>
              <th class="text-left">Open Bets</th>
              <td>{{ activeAccount.totalOpenBets.amount || 0 }}</td>
            </tr>
            <tr>
              <th class="text-left">Bonus</th>
              <td>
                {{ activeAccount.account.bonus.amount || 0 }} {{ activeAccount.account.currency }} ({{ (activeAccount.account.bonus.rollover_init - activeAccount.account.bonus.rollover).toFixed(2) }}/{{ activeAccount.account.bonus.rollover_init }})
              </td>
            </tr>
            <tr>
              <th class="text-left">Bonus Sport</th>
              <td>
                {{ activeAccount.account.bonus_sport.amount || 0 }} {{ activeAccount.account.currency }} ({{ (activeAccount.account.bonus_sport.rollover_init - activeAccount.account.bonus_sport.rollover).toFixed(2) }}/{{ activeAccount.account.bonus_sport.rollover_init }})
              </td>
            </tr>

            <tr>
              <th class="text-left">Freespins</th>
              <td>{{ activeAccount.account.freespins || 0 }}</td>
            </tr>

            <tr>
              <th class="text-left">Overdraft</th>
              <td>{{ activeAccount.account.overdraft.amount || 0 }}/{{ activeAccount.account.overdraft.total || 0 }} {{ activeAccount.account.currency }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <v-btn color="info" @click="$store.dispatch('manual_transaction/open', activeAccount.account)" dark small v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: ['balance', 'refund', 'bonus', 'freespins']})">
                  <v-icon class="mr-2">monetization_on</v-icon>
                  <template v-if="$vuetify.breakpoint.name == 'sm'">Manual Transaction</template>
                  <template v-else>MT</template>
                </v-btn>
                <v-btn color="info" class="float-right" @click="refresh(activeAccount.account)" dark small :loading="refreshing">
                  <v-icon class="mr-2">refresh</v-icon>
                  Refresh
                </v-btn>
                <v-btn color="info" class="float-right" @click="forceLogout(activeAccount.account)" dark small :loading="refreshing">
                  <v-icon class="mr-2">mdi-logout</v-icon>
                  Force Logout
                </v-btn>
              </td>
            </tr>
          </tbody>

        </template>
      </v-simple-table>
      <v-simple-table
        v-else
        class="pa-0 col-12 account-short-info"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">ID</th>
              <th class="text-left">Login (Project: {{ activeAccount.account.project }})</th>
              <th class="text-left">Status</th>
              <th class="text-left">Type</th>
              <th class="text-left">Online</th>
              <th class="text-left">
                VIP
                <default-history
                  class="d-inline-block"
                  type="vip"
                  handler="default"
                  icon="history"
                  color="white"
                  size="small"
                  icon-size="19px"
                  title="VIP Change History"
                />
              </th>
              <th class="text-left">Duplicates</th>
              <th class="text-left">Balance</th>
              <th class="text-left">Open Bets</th>
              <th class="text-left">Bonus / Bonus Sport</th>
              <th class="text-left">Overdraft</th>
              <th class="text-left">Freespins</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ activeAccount.account.account_id }}</td>
              <td>{{ activeAccount.account.login }}
                <v-icon small :title="activeAccount.account.platform">{{ platform }}</v-icon>
                <v-icon color="yellow darken-3" v-if="activeAccount.account.vip">mdi-chess-king</v-icon>
              </td>
              <td
                :class="{
                  'text-capitalize': true,
                  'font-weight-bold': accountStatus !== 'open',
                  'red--text': accountStatus !== 'open',
                }"
              >{{ accountStatus }}</td>
              <td>{{ activeAccount.account.type }}</td>
              <td>{{ activeAccount.account.online ? 'On' : 'Off' }}</td>
              <td>

                <v-checkbox
                  v-model="activeAccount.account.vip"
                  hide-details
                  class="ma-0 px-0 float-left"
                  :readonly="!$store.state.auth.checkAccess({key: 'vip_update', value: true})"
                  v-on:change="!$store.state.auth.checkAccess({key: 'vip_update', value: true}) || toUpdate($event, 'vip', 'Confirm VIP changes?')"
                />
              </td>
              <td v-html="duplicates"></td>
              <td>
                {{ activeAccount.account.balance || 0 }} {{ activeAccount.account.currency }}
              </td>
              <td>{{ activeAccount.totalOpenBets.amount || 0 }} {{ activeAccount.account.currency }}</td>
              <td>
                {{ activeAccount.account.bonus.amount || 0 }} {{ activeAccount.account.currency }} ({{ (activeAccount.account.bonus.rollover_init - activeAccount.account.bonus.rollover).toFixed(2) }}/{{ activeAccount.account.bonus.rollover_init }})
                <br />
                {{ activeAccount.account.bonus_sport.amount || 0 }} {{ activeAccount.account.currency }} ({{ (activeAccount.account.bonus_sport.rollover_init - activeAccount.account.bonus_sport.rollover).toFixed(2) }}/{{ activeAccount.account.bonus_sport.rollover_init }})
              </td>
              <td>{{ activeAccount.account.overdraft.amount || 0 }}/{{ activeAccount.account.overdraft.total || 0 }} {{ activeAccount.account.currency }}</td>
              <td>{{ activeAccount.account.freespins || 0 }}</td>
              <td>
                <v-btn
                  v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: ['balance', 'refund', 'bonus', 'freespins']})"
                  color="info"
                  dark
                  icon
                  @click="$store.dispatch('manual_transaction/open', activeAccount.account)"
                >
                  <v-icon>monetization_on</v-icon>
                </v-btn>
                <v-btn color="info" @click="refresh(activeAccount.account)" dark icon :loading="refreshing">
                  <v-icon>refresh</v-icon>
                </v-btn>
                <v-btn
                  v-if="$store.state.auth.checkAccess({ key: 'manual_notifications', value: true })"
                  color="info"
                  dark
                  icon
                  @click="isManualNotificationDialogVisible = true"
                >
                  <v-icon v-text="'mdi-send'" />
                </v-btn>

                <v-btn
                  color="info"
                  icon
                  dark
                  :loading="refreshing"
                  @click="isNotificationListVisible = true"
                >
                  <v-icon v-text="'mdi-bell'" />
                </v-btn>
                <v-btn
                  v-if="$store.state.auth.checkAccess({key: 'force_logout', value: true})"
                  :loading="refreshing"
                  color="info"
                  dark
                  icon
                  @click="forceLogout(activeAccount.account)"
                >
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>

        </template>
      </v-simple-table>
    </div>

    <v-dialog v-model="isNotificationListVisible" max-width="1200px">
      <notification-list-container
        :is-visible="isNotificationListVisible"
        :account="activeAccount.account"
      />
    </v-dialog>

    <v-dialog v-model="isManualNotificationDialogVisible" max-width="1200px">
      <manual-notification-container
        :is-visible="isManualNotificationDialogVisible"
        :account="activeAccount.account"
        :has-notification-template-access="$store.state.auth.checkAccess({key: 'notification_center', value: true})"
        @close="isManualNotificationDialogVisible = false"
      />
    </v-dialog>

    <user-dashboard :key="`dashboard`" :value="`dashboard`" v-show.visible="'dashboard' == infoTab" @show-manual-notification="isManualNotificationDialogVisible = true"></user-dashboard>
    <user-finance :key="`finance`" :value="`finance`" title="Finance" v-show.visible="'finance' == infoTab"></user-finance>
    <user-statistic :key="`statistic`" :value="`statistic`" title="Statistic" v-show.visible="'statistic' == infoTab"></user-statistic>
    <user-bonuses :key="`bonuses`" :value="`bonuses`" title="User Bonuses" v-show.visible="'bonuses' == infoTab"></user-bonuses>
    <user-game-history :key="`game-history`" title="Game History" :value="`game-history`" v-show.visible="'game-history' == infoTab"></user-game-history>
    <user-sport-history :key="`sport-history`" title="Sport History" :value="`sport-history`" v-show.visible="'sport-history' == infoTab"></user-sport-history>
    <duplicates v-if="$store.state.auth.checkAccess({key: 'duplicates', value: true})" :key="`duplicates`" title="Duplicates" :value="`duplicates`" v-show.visible="'duplicates' == infoTab"></duplicates>
    <limits v-if="$store.state.auth.checkAccess({key: 'limits', value: true})" :key="`limits`" title="Duplicates" :value="`limits`" v-show.visible="'limits' == infoTab"></limits>

  </v-container>
</template>

<style>

  .user-main-view {
    border-top: 1px solid #c0c1c2;
  }

  .account-header-info {
    border-top: 1px solid #dddddd !important;
    border-bottom: 1px solid #dddddd !important;
  }

  .account-header-info .v-toolbar__content > .v-tabs:first-child,
  .account-header-info .v-toolbar__extension > .v-tabs:first-child {
    margin-left: 0;
  }

  .account-header-info > div {
    padding-left: 0;
  }

  .account-header-info table {
    background: transparent;
  }

  .account-short-info th {
    color: #FEFEFE !important;
    padding: 0 6px !important;
  }

  .account-short-info tbody {
    background: #FEFEFE !important;
    color: rgba(0, 0, 0, 0.87);
  }

  .account-short-info tbody td:first-child {
    border-bottom-left-radius: 4px;
  }

  .account-short-info tbody td:last-child {
    border-bottom-right-radius: 4px;
  }

  .account-short-info tbody td {
    padding: 0 6px !important;
  }

  .account-short-info,
  .account-short-info.theme--light.v-data-table tbody tr:hover {
    background: none !important;
  }

  .account-info-tabs {
    overflow: hidden;
  }

</style>

<script>
  import { get } from 'lodash'
  import { mapGetters } from 'vuex'
  import { duplicatesFlags } from '@/utils/helper'
  import { API } from '@/utils/api'

  export default {
    props: [],

    data: () => ({
      refreshing: false,
      isNotificationListVisible: false,
      isManualNotificationDialogVisible: false,
      // infoTabs: 'dashboard'
    }),
    components: {
      ManualTransaction: () => import('@/components/helper/ManualTransaction'),
      UserDashboard: () => import('@/components/user/dashboard/MainView'),
      UserFinance: () => import('@/components/user/finance/MainView'),
      UserBonuses: () => import('@/components/user/bonus/MainView'),
      UserGameHistory: () => import('@/components/user/game-history/MainView'),
      UserSportHistory: () => import('@/components/user/sport-history/MainView'),
      UserStatistic: () => import('@/components/user/statistic/MainView'),
      Duplicates: () => import('@/components/user/duplicates/MainView'),
      Limits: () => import('@/components/user/limits/MainView'),
      DefaultHistory: () => import('@/components/helper/DefaultHistory'),
      NotificationListContainer: () => import('@/modules/notification-list').then(module => module.NotificationListContainer),
      ManualNotificationContainer: () => import('@/modules/manual-notifications').then(module => module.ManualNotificationContainer),
    },

    computed: {
      ...mapGetters({ activeAccount: 'account/active', infoTab: 'account/infoTab' }),
      duplicates: function () {
        return duplicatesFlags(this.activeAccount.account.duplicates)
      },
      platform: function () {
        let platformMap = {
          desktop: 'mdi-monitor',
          mobile: 'mdi-cellphone',
          default: 'mdi-monitor',
        }

        return platformMap[this.activeAccount.account.platform] ? platformMap[this.activeAccount.account.platform] : platformMap.default
      },

      accountStatus() {
        return this.activeAccount.account.frozen ? 'closed' : 'open'
      }
    },

    methods: {
      toUpdate: async function (val, field, message) {
        if (await this.$root.$confirm('Confirm', message)) {

          API.call('/$v/account/update.json', {
            login: this.activeAccount.account.login,
            account_id: this.activeAccount.account.account_id,
            fields: { [field]: get(this.activeAccount.account, field) },
            init_fields: { [field]: get(this.activeAccount.initAccount, field) },
          }, this.activeAccount.account).then(resp => {

            _.set(this.activeAccount.initAccount, field, get(resp.data, field))

            return resp.data
          }).then(r => {
            this.$showSuccess('Account updated')
          }).catch(e => {
          })

        } else {
          this.$nextTick(() => {
            _.set(this.activeAccount.account, field, get(this.activeAccount.initAccount, field))
          })
        }
      },
      refresh: async function (account) {

        if (await this.$root.$confirm('Confirm', 'All changes will be declined, save it before reload')) {
          this.refreshing = true
          this.$store.dispatch('account/load', { value: account.login, account_id: account.account_id, login: account.login }).then(resp => {
            this.$store.commit('account/refresh', resp.data)
          }).then(() => {
            return this.$store.dispatch('auth/recentViewLoad', {})
          }).then(() => {
            return this.$store.dispatch('account/loadKYC', { account: { value: account.login, account_id: account.account_id, login: account.login } })
          }).catch(e => {
            this.$showError(get(e, 'response.data', get(e, 'response', e)).message)
          }).finally(() => {
            this.refreshing = false
          })
          this.$store.dispatch('account/loadRecentTransactions', this.activeAccount.account).catch(e => {
            this.$showError(e.response.data.message)
          })
        }
      },
      forceLogout: async function (account) {
        if (await this.$root.$confirm('Confirm', 'All changes will be declined, save it before reload')) {
          API.call('/$v/account/force_logout.json', {
            login: account.login,
            account_id: account.account_id,
          }, account).then(resp => {
            return resp.data
          }).then(r => {
            this.$showSuccess('Account Logged Out')
          }).catch(e => {
          })
        }
      },
    }
  }
</script>
